import React from 'react';
import { Phone, Mail, Calendar, ArrowRight, CheckCircle, Clock } from 'lucide-react';
import { contactInfo, ctaContent, images } from '../mock';

export const FinalCTA = () => {
  const handleScheduleClick = () => {
    window.location.href = `mailto:${contactInfo.email}?subject=Schedule a Consultation - The Cellular Recovery Network`;
  };

  const handlePhoneClick = () => {
    window.location.href = `tel:${contactInfo.phone.replace(/\s/g, '')}`;
  };

  return (
    <section id="contact" style={{
      position: 'relative',
      padding: '8rem 1.5rem',
      color: 'white',
      overflow: 'hidden'
    }}>
      {/* Mountain Background */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: 'url(https://images.unsplash.com/photo-1454496522488-7a8e488e8606?w=1920&q=80)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        zIndex: 0
      }} />
      
      {/* Dark Blue-Gray Overlay */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'linear-gradient(135deg, rgba(45, 56, 65, 0.9) 0%, rgba(58, 65, 73, 0.85) 50%, rgba(67, 75, 84, 0.9) 100%)',
        zIndex: 1
      }} />
      
      <div className="container" style={{ position: 'relative', zIndex: 2 }}>
        <div style={{
          maxWidth: '1000px',
          margin: '0 auto'
        }}>
          {/* Main Heading */}
          <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
            <h2 style={{
              fontFamily: "'Playfair Display', Georgia, serif",
              fontSize: 'clamp(2rem, 4vw, 3rem)',
              lineHeight: 1.2,
              fontWeight: 700,
              marginBottom: '1.5rem',
              letterSpacing: '-0.01em',
              fontStyle: 'italic'
            }}>
              {ctaContent.heading}
            </h2>
            
            <h3 style={{
              fontFamily: "'Playfair Display', Georgia, serif",
              fontSize: 'clamp(1.5rem, 2.5vw, 2rem)',
              lineHeight: 1.3,
              fontWeight: 600,
              marginBottom: '1.5rem',
              color: '#7EC0D6',
              fontStyle: 'italic'
            }}>
              {ctaContent.subheading}
            </h3>
            
            <p style={{
              fontFamily: "'Open Sans', sans-serif",
              fontSize: 'clamp(1.125rem, 2vw, 1.25rem)',
              lineHeight: 1.6,
              maxWidth: '800px',
              margin: '0 auto',
              color: '#E0E0E0'
            }}>
              {ctaContent.description}
            </p>
          </div>

          {/* Benefits */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '1.5rem',
            marginBottom: '4rem'
          }}>
            {ctaContent.benefits.map((benefit, index) => (
              <div key={index} style={{
                display: 'flex',
                alignItems: 'center',
                gap: '1rem',
                background: 'rgba(92, 112, 128, 0.5)',
                backdropFilter: 'blur(10px)',
                padding: '1.5rem',
                borderRadius: '0.75rem',
                border: '1px solid rgba(255, 255, 255, 0.15)'
              }}>
                <CheckCircle size={24} style={{ flexShrink: 0, color: '#00BFFF' }} />
                <span style={{ fontFamily: "'Open Sans', sans-serif", fontSize: '1rem', fontWeight: 500 }}>{benefit}</span>
              </div>
            ))}
          </div>

          {/* CTA Buttons */}
          <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
            <button 
              onClick={handleScheduleClick}
              style={{
                background: '#00BFFF',
                color: '#1a1a2e',
                border: 'none',
                borderRadius: '0.75rem',
                padding: '1.25rem 2.5rem',
                fontSize: '1.125rem',
                fontWeight: 700,
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.75rem',
                boxShadow: '0 15px 35px rgba(0, 191, 255, 0.3)',
                marginBottom: '1.5rem',
                fontFamily: "'Open Sans', sans-serif"
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-4px)';
                e.target.style.boxShadow = '0 20px 45px rgba(0, 191, 255, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 15px 35px rgba(0, 191, 255, 0.3)';
              }}
            >
              <Calendar size={28} />
              Schedule Your Free Assessment
              <ArrowRight size={28} />
            </button>
            
            <div style={{ opacity: 0.9 }}>
              <p style={{ fontSize: '0.875rem', marginBottom: '0.5rem' }}>Or contact us directly:</p>
              <div style={{ display: 'flex', gap: '2rem', justifyContent: 'center', flexWrap: 'wrap' }}>
                <button
                  onClick={handlePhoneClick}
                  style={{
                    background: 'transparent',
                    border: 'none',
                    color: 'white',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    fontSize: '1.125rem',
                    fontWeight: 600,
                    textDecoration: 'underline'
                  }}
                >
                  <Phone size={20} />
                  {contactInfo.phone}
                </button>
                <button
                  onClick={handleScheduleClick}
                  style={{
                    background: 'transparent',
                    border: 'none',
                    color: 'white',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    fontSize: '1.125rem',
                    fontWeight: 600,
                    textDecoration: 'underline'
                  }}
                >
                  <Mail size={20} />
                  {contactInfo.email}
                </button>
              </div>
            </div>
          </div>

          {/* Urgency */}
          <div style={{
            background: 'rgba(92, 112, 128, 0.5)',
            backdropFilter: 'blur(10px)',
            border: '2px solid rgba(0, 191, 255, 0.3)',
            borderRadius: '1rem',
            padding: '2rem',
            textAlign: 'center'
          }}>
            <Clock size={48} style={{ marginBottom: '1rem', color: '#00BFFF' }} />
            <p style={{
              fontSize: '1.125rem',
              lineHeight: '1.7',
              fontWeight: 500,
              color: '#E0E0E0'
            }}>
              {ctaContent.urgency}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
